<template>
  <div class="page">
    <div class="bag-item-wrap" v-if="currentBag">
      <div
        class="bag-item"
        :style="{
          backgroundImage: `url('${currentBag.coverImagUrl}')`,
          ...videoHeightStyle
        }"
      >
        <!--        <div class="bag-title">{{ currentBag.title }}</div>-->
        <div class="tag">{{ currentBag.tag }}</div>
      </div>
      <div class="wrap">
        <div class="desc">{{ currentBag.subTitle }}</div>
        <div class="sort" @click="sort">
          排序
          <img
            :src="
              require(isAsc
                ? '../../static/ic_sort_up.png'
                : '../../static/ic_sort_down.png')
            "
          />
        </div>
      </div>
    </div>
    <div class="content-wrap">
      <van-list
        v-model="loading"
        :finished="pageEnd"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <CourseItem
          v-for="(item, index) in courseList"
          :key="index"
          :productId="productId"
          :couponNo="couponNo"
          :CourseItemData="item"
        ></CourseItem>
      </van-list>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from '@vue/composition-api'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { List } from 'vant'
import CourseItem from '../../components/CourseItem/CourseItem.vue'
import api from '../../api/api'
import util from '@/util/util'
dayjs.extend(isBetween)
export default {
  name: 'UnlockCourse',
  components: {
    CourseItem,
    'van-list': List
  },
  data() {
    return {
      currentBag: this.$store.getters.getCurrentBag
    }
  },
  created() {
    document.title = this.currentBag.title
  },
  computed: {
    videoHeightStyle() {
      return {
        height: util.getVideoHeight() + 'px'
      }
    }
  },

  setup(props, { root }) {
    console.info(props)
    const setId = root.$route.query.setId
    const productId = root.$route.query.productId
    const couponNo = root.$route.query.couponNo

    const state = reactive({
      viewState: '',
      courseList: [],
      value: '',
      loading: false,
      pageEnd: false,
      isAsc: false
    })

    async function lookCourseListData(isRest) {
      if (isRest) {
        state.viewState = ''
        state.pageEnd = false
        state.courseList = []
      }
      state.loading = true
      const { detail, result } = await api.course.getUnlockCourseList(
        {
          courseSetId: setId,
          orderBy: state.isAsc ? 1 : 2,
          direction: 2,
          pageSize: 10
        },
        state.viewState
      )
      if (result.code === 0) {
        console.info('detail', detail)
        const list = detail.page.list.filter(item => item.index !== 0)
        if (isRest) {
          state.courseList = list
        } else {
          state.courseList = state.courseList.concat(list)
        }
        state.pageEnd = detail.page.end
        state.viewState = result.viewState
        state.loading = false
      }
    }

    function onLoad() {
      lookCourseListData()
    }

    function sort() {
      state.isAsc = !state.isAsc
      lookCourseListData(true)
    }

    return {
      ...toRefs(state),
      dayjs,
      onLoad,
      productId,
      couponNo,
      sort
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0 30px;
  .desc {
    width: fit-content;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 80px;
    background: rgba(240, 175, 90, 1);
    color: rgba(50, 50, 50, 1);
    font-size: 24px;
    padding: 0 20px;
    max-width: 268px;
    flex: none;
  }
  .sort {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: rgba(50, 50, 50, 1);
    img {
      margin-left: 10px;
      width: 14px;
      height: 20px;
    }
  }
}

.bag-item {
  position: relative;
  width: 100%;
  height: 240px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bag-title {
    padding: 20px 0 0 20px;
    color: #ffffff;
    font-size: 50px;
    font-weight: bold;
  }
  .tag {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: rgba(0, 0, 0, 0.25);
    color: #ffffff;
    font-size: 24px;
    padding: 0 10px;
    border-radius: 4px;
  }
}
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .search-wrap {
    flex: none;
    .van-search {
      padding: 10px 30px;
      border-radius: 4px;
      ::v-deep {
        .van-search__content {
          border-radius: 40px;
        }
      }
    }
  }
  .content-wrap {
    flex: auto;
    overflow-y: auto;
    padding: 0 30px;
    margin-top: 20px;
  }
}
</style>
